module.exports = __webpack_public_path__ + "img/dsci0004.77911c75.jpg";